import styled from "styled-components";

import { SPACING_VALUES } from "shared/config/spacing";

export const StyledVStack = styled.div((props) => {
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: props.$align,
        gap: props.$spacing ? SPACING_VALUES[props.$spacing] : "0",
    };
});
